import { render } from "./editExhibitionManage.vue?vue&type=template&id=485cb7b6"
import script from "./editExhibitionManage.vue?vue&type=script&setup=true&lang=js"
export * from "./editExhibitionManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/editExhibitionManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "485cb7b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('485cb7b6', __exports__)) {
    console.log('reload')
    api.reload('485cb7b6', __exports__)
  }
  
  module.hot.accept("./editExhibitionManage.vue?vue&type=template&id=485cb7b6", () => {
    console.log('re-render')
    api.rerender('485cb7b6', render)
  })

}


export default __exports__